import React, { Component, Fragment, useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col, Card, CardBody } from "reactstrap"

import Breadcrumbs from "../../../components/Common/Breadcrumb2"
import SoftskillsCoursesListTable from "components/SoftSkills/Courses/SoftskillsCoursesListTable"

const SoftskillsCoursesList = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Cursos | Soft Skills</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col sm={4}>
              <h4>Catálogo de cursos</h4>
            </Col>
            <Col sm={8}>
              <Breadcrumbs
                breadcrumbItems={[
                  { key: "dashboard", title: "Inicio", link: "/soft-skills" },
                  { key: "courses", title: "Cursos" },
                ]}
              />
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <SoftskillsCoursesListTable />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SoftskillsCoursesList
